import React from 'react';
import styled, { DefaultTheme } from 'styled-components';
import { Intent } from '../utilities';
import { IHasTestData } from '../../test-utilities/IHasTestData';
import type { FCWithChildren } from '../../../types/FCWithChildren';

const intentColor = {
  primary: (theme: DefaultTheme) => theme.colors.primary,
  secondary: (theme: DefaultTheme) => theme.colors.blue,
  ghost: (theme: DefaultTheme) => theme.colors.primary,
  danger: (theme: DefaultTheme) => theme.colors.error,
};
const intentBackground = {
  primary: (theme: DefaultTheme) => theme.colors.primaryOpacity20,
  secondary: (theme: DefaultTheme) => theme.colors.blueLightest,
  ghost: () => '',
  danger: (theme: DefaultTheme) => theme.colors.errorBackground,
};

const Strong = styled.div<{ intent: Intent }>`
  font-weight: ${({ theme }) => theme.fonts.semiBoldWeight};
  padding: ${({ theme }) => theme.spacing.spacing2} ${({ theme }) => theme.spacing.spacing4};
  text-align: center;
  ${({ theme }) => theme.fonts.tinySize};
  text-transform: uppercase;
  color: ${({ theme, intent }) => intentColor[intent](theme)};
  background-color: ${({ theme, intent }) => intentBackground[intent](theme)};
`;

export interface IBadgeProps extends IHasTestData {
  intent: Intent;
}
export const Badge: FCWithChildren<IBadgeProps> = ({ intent, children, ...rest }) => {
  return (
    <Strong
      intent={intent}
      data-test-class={rest['data-test-class'] || 'badge'}
      data-test-id={rest['data-test-id'] || `badge-${children}`}
    >
      {children}
    </Strong>
  );
};
